import { zipSync, strToU8 } from "fflate";
export async function buildPackZip(pack, fonts, {signal, onProgress=()=>{}, fetcher=fetch}={}) {
  const entries = {};
  const metadata = [];
  for (let i=0;i<pack.fontIds.length;i++){
    signal?.throwIfAborted();
    const font=fonts.find(f=>f.id===pack.fontIds[i]);
    if(!font?.file) throw new Error("Missing font in pack");
    const response=await fetcher(font.file,{signal});
    if(!response.ok) throw new Error("Font download failed");
    const bytes=new Uint8Array(await response.arrayBuffer());
    if(bytes.length<12 || !((bytes[0]===0&&bytes[1]===1) || ["OTTO","true","typ1","wOFF","wOF2"].includes(String.fromCharCode(...bytes.slice(0,4))))) throw new Error("Invalid font response");
    entries["fonts/"+font.id+"-"+(font.filename||font.name).replace(/[^a-zA-Z0-9._-]/g,"_")]=bytes;
    metadata.push({id:font.id,name:font.name,style:font.style,encoding:font.encoding,authors:font.authors,source:font.source,licenseText:font.licenseText,licenseUrl:font.licenseUrl,licenseCopyright:font.licenseCopyright});
    onProgress(i+1,pack.fontIds.length);
  }
  signal?.throwIfAborted();
  entries["manifest.json"]=strToU8(JSON.stringify({name:pack.name,fonts:metadata},null,2));
  entries["README.txt"]=strToU8(pack.name+"\n\nOriginal font files bundled by Fontlab. See manifest.json for authors, source links, encodings and available license information. Bundling does not change the original font licenses. Legacy fonts require the appropriate text encoding.\n\n"+metadata.map(f=>f.name+" — "+f.encoding).join("\n"));
  return new Blob([zipSync(entries,{level:0})],{type:"application/zip"});
}
